import { InformationCircleIcon } from '@interstate/components/Icons/InformationCircleIcon';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { toRem } from '../../utils/pixelUtils';
import { StyledTooltip } from './BalloonTermTypeField.style';
import { BALLOON_TERM_TYPE_TOOLTIP_CONTENT } from './balloonTermTypeTooltipContent';

export const BalloonTermTypeInfo = () => {
    const theme = useInterstateTheme();

    return (
        <StyledTooltip
            backgroundColor={theme.tokens.ColorSurfaceInverseDefault}
            title={BALLOON_TERM_TYPE_TOOLTIP_CONTENT}
            placement="bottom"
            arrow
            data-testid="balloon-term-type-tooltip"
        >
            <InformationCircleIcon
                width={toRem(13)}
                height={toRem(13)}
                color={theme.tokens.BaseColorBlue500}
                data-testid="balloon-term-type-info-icon"
            />
        </StyledTooltip>
    );
};
